module.exports = __webpack_public_path__ + "img/1-1Z9161S0304C.04c378a7.jpg";